export type RangeGranularity = '1min' | '5min' | '15min' | 'hourly' | 'daily' | 'monthly';

export type GranularityRule = {
  minDays: number;
  maxDays?: number;
  fromPresets: RangeGranularity[];
  toPreset: RangeGranularity;
};

export const GRANULARITY_RULES: GranularityRule[] = [
  {
    minDays: 1,
    maxDays: 1,
    fromPresets: ['1min'],
    toPreset: '1min',
  },
  {
    minDays: 1,
    maxDays: 1,
    fromPresets: ['15min'],
    toPreset: '15min',
  },
  {
    minDays: 1,
    maxDays: 1,
    fromPresets: ['1min', '5min', '15min', 'hourly', 'daily', 'monthly'],
    toPreset: '5min',
  },
  {
    minDays: 1,
    maxDays: 3,
    fromPresets: ['1min', '5min', '15min', 'hourly', 'daily', 'monthly'],
    toPreset: 'hourly',
  },
  {
    minDays: 3,
    maxDays: 62,
    fromPresets: ['1min', '5min', '15min', 'hourly', 'daily', 'monthly'],
    toPreset: 'daily',
  },
  {
    minDays: 62,
    fromPresets: ['1min', '5min', '15min', 'hourly', 'daily', 'monthly'],
    toPreset: 'monthly',
  },
];

export function getAdjustedGranularity(
  days: number,
  currentGranularity: RangeGranularity,
  hiddenGranularities: RangeGranularity[] = []
): RangeGranularity {
  const rule = GRANULARITY_RULES.find(
    (r) =>
      days >= r.minDays &&
      (!r.maxDays || days <= r.maxDays) &&
      r.fromPresets.includes(currentGranularity) &&
      !hiddenGranularities.includes(r.toPreset)
  );
  return rule?.toPreset ?? currentGranularity;
}
